/**
 * Замена в элементе, в основном текстового, контента
 *  из его дата атрибутов.
 *
 * Удобно использовать при замене множества элементов,
 *  у которых должен свой свой индивидуальный текст,
 *  либо если этот текст зхависит от действий пользователя
 *
 * Пример - загрузка файлов. При смене инпута (file)
 *  можем узнать имя файла (если один)
 *  или их количество (при множественном выборе).
 *  Также мы можем узнать общий объем файлов и вывести все
 *  в удобный нам элемент, плюс простилизоват его.
 *
 *
 * @sourcecode jQueryExtends:changeMyText
 * @memberof   jQueryExtends
 * @requires   {@link wHelpers.replaceFromArray }
 * @param      {string}     [prop="default"] - Ключ свойтсва с которого нужно взять текст для замены
 * @param      {Array}      [replaceArray=[]] - Массив значений с которых следует сделать замену паттернов
 * @return     {undefined}
 */
$.fn.changeMyText = function (prop, replaceArray) {
	return this.each(function (index, el) {
		let $element = $(el);
		let textData = $element.data('text');

		if (typeof textData !== 'object') {
			console.warn($element, 'Не имеет данных с тектом -> data-text=\'{"key": "value"}\'');
			return true;
		}

		replaceArray = replaceArray || [];
		prop = prop || 'default';
		let value = textData[prop];

		if (typeof value !== 'string') {
			console.warn($element, 'Не имеет свойтва "' + prop + '"');
			return true;
		}

		if (replaceArray.length) {
			value = replaceFromArray(value, replaceArray);
		}

		$element.html(value);
	});
};

function replaceFromArray (replacingString, values, pattern) {
	pattern = pattern || '%s';
	if (!Array.isArray(values)) {
		values = [values];
	}

	for (let i = 0; i < values.length; i++) {
		let value = values[i];
		replacingString = replacingString.replace(pattern, value);
	}

	return replacingString;
}



// WEBPACK FOOTER //
// ./src/js/_modules/change-text.js